export default __webpack_public_path__ + "static/media/img-0004.da343e80.png";